import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import { List, ListProps, Pagination, PaginationProps } from "react-admin";

const PostPagination = (props: PaginationProps) => (
  <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />
);

export const DefaultProLogsList = (
  props: ListProps & { children: any } & Omit<
      DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
      "title"
    >
) => {
  return <List {...props} pagination={<PostPagination />} perPage={25} />;
};
